<template lang="pug">
div
  h1 {{$t('page.title')}}
  .block
    .block__content.no-pd
      .activation-form
        h2 {{$t('page.title2')}}
        .scenario__loading(v-if="stageInitialLoading")
          div.center-items
            br
            circle-loader(size="35px") {{$t('Загрузка...')}}
        .scenario__choice(v-if="hasScenarioChoice" :class="scenarioChoiceClass")
          div.alert.alert-warning.alert-has-already
            | {{$t('page.activated_line1')}}
            br
            template(v-if="disablingAllowed")
              i18n(path="page.activated_line2" tag="span")
                template(v-slot:disablelink)
                  a(href="#" @click.prevent="setDisactivationStage" :class="disactivateLinkClass") {{$t('отключить его')}}
                template(v-slot:enablelink)
                  a(href="#" @click.prevent="setActivationStage" :class="activateLinkClass") {{$t('активировать другой сид')}}
            //template(v-else)
              i18n(path="page.activated_line2_1" tag="span")
                template(v-slot:enablelink)
                  a(href="#" @click.prevent="setActivationStage" :class="activateLinkClass") {{$t('активировать другой сид')}}

        template(v-if="!stageInitialLoading")
          .scenario__activation_googlecode(v-if="scenarioActivation")
            h3.h3__title {{$t('page.activate_new_title')}}
            template(v-if="hasScenarioChoice")
              div.h3__hint {{$t('page.activate_new_hint')}}
            div.notice
              i18n(path="page.notice.hint.line1" tag="span")
                template(v-slot:android)
                  a(href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2") Android
                template(v-slot:ios)
                  a(href="https://apps.apple.com/ru/app/google-authenticator/id388497605") iOS

              br
              | {{$t('page.notice.hint.line2')}}

              br
              br
              | {{$t('page.notice.hint.line3')}}
              |
              |
              a(href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai") {{$t('Плагин Google Chrome')}}


            br


            template
              //(v-if="showQrCodeStage/*&& !stageActivationVerification*/")
              .seed-block(:class="seedBlockClass")

                div.instruction
                  ol.numbered-list
                    li
                      i18n(tag="h4" path="page.instruction.line1").li_title
                        template(v-slot:appname)
                          strong Google Authenticator
                        template(v-slot:token)
                          strong {{$t('токен аккаунта')}}
                      template(v-if="showQrCodeStage")
                        div.qrcode-side
                          template
                            div.qrcode-wrap
                              template(v-if="!stageSeedGeneration && model.values.seed")
                                qrcode-styling(:source-data="seedData" :qrcode-styling-config="qrcodeConfig")
                              .qrcode-generation(v-if="stageSeedGeneration")
                                circle-loader {{$t('Генерируется новый токен...')}}
                            .token-info
                              dl
                                dt {{$t('Токен аккаунта (ключ)')}}:
                                dd
                                  template(v-if="!stageSeedGeneration") {{ model.values.seed }}
                                  template(v-if="stageSeedGeneration") --------------
                              .token-info__buttons
                                button.btn.btn-success-outline(@click.prevent="regenerateSeed" :disabled="stageSeedGeneration") {{$t('Сгенерировать другой')}}
                              .token-info__hint {{$t('page.token_hint')}}
                          //template(v-if="stageSeedGeneration")
                            .qrcode-generation(v-if="stageSeedGeneration")
                              circle-loader {{$t('Генерируется новый токен...')}}
                        template(v-if="stageActivationChoice && hasVerificationOptions")
                          br
                          br
                          regular-form-style
                            .form-group
                              .input-controls.submit-buttons
                                button(@click.prevent="goSelectVerification" :disabled="!stageActivationChoice").btn.btn-success {{$t('Далее')}}
                    li(v-if="showSelectVerificationStage" :class="selectVerificationClass")
                      h4.li_title {{$t('Выберите способ подтверждения')}}
                      //div {{$t('page.instruction.line2')}}
                      template(v-if="showSelectVerificationStageContent")
                        //(v-if="!stageSeedGeneration && stageShowCreateEnablingDocument")
                        div
                          br
                          br
                        regular-form-style
                          .form-group
                            .label-control
                              label.control-label.required {{$t('Способ верификации')}}
                            .input-controls
                              select-verification-type(:visible-options="verificationOptions" :disabled="stageCreatingActivationDocument && !stageActiveSelectVerificationType" v-model="model.values.verificationType")
                            .input-controls
                              error-message-block(:errors="model.errors" attribute="*|verificationType")
                            //dropdown-key-value(:options="verificationOptions")
                          br
                          //(v-if="stageShowCreateEnablingDocument")
                          .form-group
                            .input-controls.submit-buttons.grid-flex-buttons
                              button(@click.prevent="goStageQrcodeScan").btn.btn-success-outline {{$t('Назад')}}
                              button(@click.prevent="createEnablingDocument" :disabled="stageCreatingActivationDocument").btn.btn-success {{$t('Далее')}}
                            //button(@click.prevent="activateSms").btn.btn-success Активировать SMS
                    //li(v-if="hasVerificationOptions").disabled-li
                      div {{$t('Введите код из приложения')}}
                    li(v-if="!hasVerificationOptions"  :class="verifyNoneClass")
                      h4.li_title  {{$t('Введите код из приложения')}}
                      template(v-if="!stageSeedGeneration")
                        div
                          br
                          br
                        regular-form-style
                          .form-group
                            .label-control
                              .control-label.required {{$t('Код из приложения')}}
                            .input-controls
                              input(type="text" v-model="model.values.pin" :disabled="activationNoneLoading").form-control
                            .input-controls
                              error-message-block(:errors="model.errors" attribute="*|verificationType")
                          br
                          .form-group
                            .input-controls
                              button(@click.prevent="activateNone" :class="activateNoneClass" :disabled="activateNoneDisabled").btn.btn-success {{$t('Активировать')}}

                    li(v-if="showVerificationStage && verificationSource")
                      h4.li_title  {{$t('Подтверждение')}}
                      template(v-if="showVerificationStageContent")
                        div
                          br
                          br
                        //template(v-if="scenarioActivation")
                          regular-form-style
                            .form-group
                              .input-controls
                                h4 {{$t('Новый код Google 2FA')}}

                        verification-form(:source="verificationSource" @verification-done="onVerificationDone" @verification-cancel="onVerificationCancel")
                          template(v-slot:beforeForm="slotProps")
                            form(role="form" v-if="model.values.activate").verification-form__body
                              .form-group
                                .label-control
                                  div.control-label.required {{$t('enter_new_code_placeholder')}}
                                .input-controls
                                  google-code-input(v-model="verificationSource.googleCodeTestForActivation" :placeholder="$t('enter_new_code_placeholder')+''")
                                  //input(type="text" v-model="verificationSource.googleCodeTestForActivation").form-control
                                .input-controls
                                  error-message-block(attribute="pin" :errors="verificationSource.verificationErrors")
                                .input-controls
                                  br
                                  payout-hint-panel {{$t('enter_code_hint')}}

                            br
                            br
                            //regular-form-style
                            //  .form-group
                            //    .input-controls
                            //      h4 {{$t('Подтверждение')}}
                    template(v-if="showSuccess")
                      li
                        h4.li_title {{$t('Поздравляем!')}}
                        div
                          br
                        p {{$t('page.activation_result.line1')}}
                        p {{$t('page.activation_result.line2')}}
                        div.success-finish-buttons
                          a(href="/security").btn.btn-success-outline {{$t('Вернуться к настройкам безопасности')}}

          .scenario__deactivation_googlecode(v-if="scenarioDeactivation")
            h3.h3__title {{$t('Отключение Google Authenticator')}}
            br
            div.instruction
              ol.numbered-list
                li
                  h4.li_title {{$t('Выберите способ подтверждения')}}
                  // div.notice-disabling
                  template(v-if="stageDisactivationChoice")
                    br
                    br
                    regular-form-style
                      .form-group
                        .label-control
                          .control-label.required {{$t('Способ верификации')}}
                        .input-controls
                          select-verification-type(:visible-options="verificationOptions" :disabled="isDocumentCreating" v-model="model.values.verificationType")
                        .input-controls
                          error-message-block(:errors="model.errors" attribute="*|verificationType")

                      br
                      .form-group
                        .input-controls
                          button(@click.prevent="createDisablingDocument" :class="disableNextClass").btn.btn-success {{$t('Далее')}}
                li(v-if="showDisVerificationStage")
                  h4.li_title {{$t('Подтверждение')}}
                  template(v-if="showDisVerificationStageContent")
                    div
                      br
                    verification-form(:source="verificationSource"
                      @verification-done="onVerificationDone" @verification-cancel="onVerificationCancel")

                li(v-if="isDeactivationSuccess")
                    //template
                    h4.li_title  {{$t('Google 2FA отключен!')}}
                    div
                      br
                    p {{$t('page.disable_result.line1')}}
                    .success-finish-buttons
                      a(href="/security").btn.btn-success-outline {{$t('Вернуться к настройкам безопасности')}}




</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";
import HorizontalForm from "@/views/pages/basic/HorizontalForm.vue";
import HorizontalFormGroup from "@/components/forms/horizontal/HorizontalFormGroup.vue";
import HorizontalPayoutFormGroup from "@/components/forms/horizontal/HorizontalFormGroup.vue";
import QrcodeStyling from "@/components/other/QrcodeStyling.vue";
import {
  GooglecodeSettingsModel,
  SecurityActivationModelInterface
} from "@/views/pages/security/security";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import DropdownKeyValue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import SelectVerificationType from "@/views/pages/security/SelectVerificationType.vue";
import {VerificationTypes} from "@/models/verification/verification";
import CircleLoader from "@/components/loaders/CircleLoader.vue";
import PayoutVerificationOtp from "@/components/payout/verification/PayoutVerificationOtp.vue";
import VerificationForm from "@/components/verification/VerificationForm.vue";
import {SecurityVerificationSource} from "@/components/verification/verification";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import GoogleCodeInput from "@/components/forms/googlecode/GoogleCodeInput.vue";
import RegularFormStyle from "@/components/forms/styling/RegularFormStyle.vue";
import PayoutHintPanel from "@/components/forms/payout/PayoutHintPanel.vue";

enum FormStageEnum {
  Loading,
  ActivationChoice,
  ActivationTokenGeneration,
  DisactivationChoice,
  DisactivationCreatingDocument,
  ActivationCreatingDocument,
  ActivationSelectVerification,
  ActivationVerification,
  DisactivationVerification,
  ActivationSuccess,
  DisactivationSuccess,
}

@Component({
  name: "googlecode-settings-page",
  components: {
    PayoutHintPanel,
    RegularFormStyle,
    GoogleCodeInput,
    ErrorMessageBlock,
    VerificationForm,
    PayoutVerificationOtp,
    CircleLoader,
    SelectVerificationType,
    DropdownKeyValue,
    PayoutInputHintBlock, QrcodeStyling, HorizontalPayoutFormGroup, HorizontalFormGroup, HorizontalForm}
})
export default class GooglecodeSettingsPage extends Vue {

  model: GooglecodeSettingsModel = new GooglecodeSettingsModel();

  stage = FormStageEnum.ActivationChoice;
  //seed = 'EKJHMDU3O4HXFD7V';

  goStageQrcodeScan() {
    this.stage = FormStageEnum.ActivationChoice;
  }

  // goStageVerificationSelect() {
  //   if (this.verificationOptions.length == 1)
  //   {
  //     this.model.values.verificationType = this.verificationOptions[0];
  //     this.stage = FormStageEnum.ActivationSelectVerification;
  //     this.createEnablingDocument();
  //   } else
  //     this.stage = FormStageEnum.ActivationSelectVerification;
  // }

  goSelectVerification() {
      if (!this.hasVerificationOptions)
      {
        this.stage = FormStageEnum.ActivationSelectVerification

      }
      else if (this.verificationOptions.length == 1)
      {
        this.model.values.verificationType = this.verificationOptions[0];
        this.stage = FormStageEnum.ActivationSelectVerification;
        this.createEnablingDocument();

      } else
        this.stage = FormStageEnum.ActivationSelectVerification;
  }

  get showDisVerificationStage() {
    return this.hasVerificationOptions && [
      FormStageEnum.DisactivationVerification,
      FormStageEnum.DisactivationSuccess
    ].indexOf(this.stage) >= 0;
  }

  get showDisVerificationStageContent() {
    return this.hasVerificationOptions
      && this.verificationSource
      && [
      FormStageEnum.DisactivationVerification,
    ].indexOf(this.stage) >= 0;
  }

  get showSelectVerificationStage() {
    if (this.lastVerificationTypeIsNone && (this.stage === FormStageEnum.ActivationSuccess))
      return false;

    return this.hasVerificationOptions && [
      FormStageEnum.ActivationCreatingDocument,,
      FormStageEnum.ActivationSelectVerification,
      FormStageEnum.ActivationVerification,
    ].indexOf(this.stage) >= 0;
  }

  get showSelectVerificationStageContent() {
    return this.hasVerificationOptions && [
      FormStageEnum.ActivationSelectVerification,
      FormStageEnum.ActivationCreatingDocument
    ].indexOf(this.stage) >= 0;
  }

  get activationNoneLoading() {
    return this.scenarioActivation
      && !this.hasVerificationOptions
      && this.model.activationStatus.isLoading
  }

  get isDocumentCreating() {
    return this.model.activationStatus.isLoading;
  }

  get disableNextClass() {
    return {
      disabled: this.isDocumentCreating
    }
  }

  get activateNoneDisabled() {
    return (!(this.scenarioActivation
            && /\d{6}/.test(this.model.values.pin)))
      || this.activationNoneLoading;
  }

  get activateNoneClass() {
    return {
      disabled: this.activateNoneDisabled
    };
  }

  get stageInitialLoading() {
    return !this.model.user;
  }

  get showVerificationStage() {
    if (this.lastVerificationTypeIsNone && (this.stage === FormStageEnum.ActivationSuccess))
      return false;

    return this.hasVerificationOptions &&
      [
        FormStageEnum.ActivationVerification,
        FormStageEnum.ActivationSuccess,
        FormStageEnum.ActivationCreatingDocument
      ].indexOf(this.stage) >= 0;
  }

  get showVerificationStageContent() {
    return [
      FormStageEnum.ActivationVerification,
      FormStageEnum.ActivationCreatingDocument
    ].indexOf(this.stage) >= 0;
  }

  get showQrCodeStage() {
    return this.stageTokenSelection
      // || this.stageCreatingActivationDocument
      // || this.
      ;
  }

  get hasScenarioChoice() {
    return this.model.user && this.model.user.security.GOOGLECODE;
  }

  get seedBlockClass() {
    return {
      'seed-block__hideqrcode': this.stageActivationVerification
    }
  }

  get stageActiveSelectVerificationType() {
    return [
      FormStageEnum.ActivationChoice
    ].indexOf(this.stage) >= 0;
  }

  get stageShowCreateEnablingDocument() {
    return [
      FormStageEnum.ActivationChoice,
      FormStageEnum.ActivationCreatingDocument,
      FormStageEnum.ActivationSelectVerification,
      FormStageEnum.ActivationVerification
    ].indexOf(this.stage) >= 0;
  }

  get stageTokenSelection() {
    return [
      FormStageEnum.ActivationChoice,
      FormStageEnum.ActivationTokenGeneration,
      FormStageEnum.ActivationVerification
    ].indexOf(this.stage) >= 0;
  }

  get isShowQRCode() {
    return this.stage == FormStageEnum.ActivationChoice;
  }

  get stageActivationVerificationSelect() {
    return this.stage === FormStageEnum.ActivationSelectVerification;
  }

  get stageActivationVerification() {
    return this.stage == FormStageEnum.ActivationVerification;
  }

  get stageActivationChoice() {
    return this.stage == FormStageEnum.ActivationChoice;
  }

  get stageSeedGeneration() {
    return this.stage == FormStageEnum.ActivationTokenGeneration;
  }

  get scenarioActivation() {
    return [
      FormStageEnum.ActivationChoice,
      FormStageEnum.ActivationSuccess,
      FormStageEnum.ActivationTokenGeneration,
      FormStageEnum.ActivationCreatingDocument,
      FormStageEnum.ActivationVerification,
      FormStageEnum.ActivationSelectVerification
    ].indexOf(this.stage) >= 0;
  }

  get scenarioDeactivation() {
    return [
      FormStageEnum.DisactivationChoice,
      FormStageEnum.DisactivationVerification,
      FormStageEnum.DisactivationSuccess,
      FormStageEnum.DisactivationCreatingDocument,
    ].indexOf(this.stage) >= 0;
  }

  get showSuccess() {
    return [FormStageEnum.ActivationSuccess, FormStageEnum.DisactivationSuccess].indexOf(this.stage) >= 0;
  }

  get isDeactivationSuccess() {
    return this.stage === FormStageEnum.DisactivationSuccess;
  }

  scenarioChoiceClass() {
    return {

    }
  }


  onVerificationDone() {
    if (this.scenarioActivation)
    {
      this.onActivated()
    } else if (this.scenarioDeactivation) {
      this.onDeactivated();
    }
    this.stage = this.scenarioActivation ? FormStageEnum.ActivationSuccess : FormStageEnum.DisactivationSuccess;
  }

  onVerificationCancel() {
    if (this.scenarioActivation)
      this.stage = FormStageEnum.ActivationSelectVerification;
    else
      this.stage = FormStageEnum.DisactivationChoice;
  }

  get activateLinkClass() {
    return {
      link: true,
      active: this.scenarioActivation,
      inactive: !this.scenarioActivation
    }
  }

  get disactivateLinkClass() {
    return {
      link: true,
      active: !this.scenarioActivation,
      inactive: this.scenarioActivation
    }
  }


  mounted() {
    this.regenerateSeed();
  }

  onActivated() {
    this.model.options.verificationType.push({value: VerificationTypes.GOOGLECODE, title: 'Google 2FA'});
    this.model.user.security.GOOGLECODE = true;
  }

  onDeactivated() {
    this.model.options.verificationType.filter(el => el.value !== VerificationTypes.GOOGLECODE);
    this.model.user.security.GOOGLECODE = false;
  }

  activateNone() {
    this.model.values.activate = true;
    this.lastVerificationTypeIsNone = !this.hasVerificationOptions;
    this.stage = FormStageEnum.ActivationCreatingDocument;
    return this.createDocument().then(() => {
      this.stage = FormStageEnum.ActivationSuccess;
      this.onActivated();
    }).catch(err => {
      this.stage = FormStageEnum.ActivationChoice;
    });

  }

  // activateSms() {
  //   this.model.activateSms();
  // }

  verificationSource: SecurityVerificationSource = null;

  setDisactivationStage() {
    this.stage = FormStageEnum.DisactivationChoice;
  }

  setActivationStage() {
    this.stage = FormStageEnum.ActivationChoice;
  }

  get stageDisactivationChoice() {
    return [
      FormStageEnum.DisactivationChoice,
      FormStageEnum.DisactivationCreatingDocument
    ].indexOf(this.stage) >= 0;
  }



  createDisablingDocument() {
    this.model.values.activate = false;
    this.stage = FormStageEnum.DisactivationCreatingDocument;
    return this.createDocument().then(() => {
      this.stage = FormStageEnum.DisactivationVerification;
    }).catch(err => {
      this.stage = FormStageEnum.DisactivationChoice;
    });
  }

  get stageCreatingActivationDocument() {
    return this.stage == FormStageEnum.ActivationCreatingDocument;
  }

  createEnablingDocument() {
    this.lastVerificationTypeIsNone = !this.hasVerificationOptions;
    this.model.values.activate = true;
    this.stage = FormStageEnum.ActivationCreatingDocument;
    return this.createDocument().then(() => {
      this.stage = FormStageEnum.ActivationVerification;
    }).catch(err => {
      this.stage = FormStageEnum.ActivationChoice;
    });
  }

  createDocument() {
    this.model.errors.clear();
    this.verificationSource = null;
    return this.model.createDocument().then((model: SecurityActivationModelInterface) => {
      const document = model.document;
      this.verificationSource = new SecurityVerificationSource();
      this.verificationSource.activation = this.model.values.activate;
      this.verificationSource.setDocument(model.document);
      this.verificationSource.service = VerificationTypes.GOOGLECODE;
    }).catch((err) => {
      throw err;
    });
  }

  get selectVerificationClass() {
    return {
      'disabled-li': this.stageSeedGeneration || this.stageActivationChoice
    }
  }

  get verifyNoneClass() {
    return {
      'disabled-li': this.stageSeedGeneration
    }
  }

  lastVerificationTypeIsNone = false

  get disablingAllowed() {
    return this.verificationOptions.length > 1;
  }


  get hasVerificationOptions(): boolean {
    if (this.verificationOptions.indexOf(VerificationTypes.NONE) >= 0)
      return false;
    return this.verificationOptions.length > 0;
  }

  get qrcodeConfig() {
    return {
      width: 250,
      height: 250
    }
  }

  get seedData() {
    const username = this.model.username;
    const label = 'Capitalist.net' + (username.length > 0 ? ':' + username : '');
    const issuer = 'Capitalist.net';
    return 'otpauth://totp/' + encodeURI(label)
        + '?secret=' + encodeURI(this.model.values.seed) + '&issuer=' + encodeURI(issuer);
  }

  regenerateSeed() {
    if (this.stageSeedGeneration) return;
    this.model.values.seed = '';
    this.stage = FormStageEnum.ActivationTokenGeneration;
    this.model.regenerateSeed().then((seed: string) => {
      this.model.values.seed = seed;
      this.stage = FormStageEnum.ActivationChoice;
    }).catch((err) => {
      this.model.values.seed = '';
      this.stage = FormStageEnum.ActivationTokenGeneration;
      throw err;
    });
  }

  get verificationOptions() {
    if (!this.model.options.verificationType)
      return [/*VerificationTypes.NONE*/];

    return this.model.options.verificationType.map((vt) => vt.value);
  }
}
</script>

<style scoped lang="less">
.activation-form {
  h2 {
    line-height: 1.4em;
  }
}
.grid-flex-buttons {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 25px;
  align-items: flex-start;
  justify-items: start;
  grid-template-columns: min-content;
}
.success-finish-buttons {
  align-items: center;
  margin-top: 2em;
  display: grid;
  justify-content: center;
}
.center-items {
  > div {
    margin: 0 auto;
  }
}
.activation-form {
  padding: 25px 40px;

  .alert {
    margin: 0;
  }

  .notice {
    //border: 1px solid #888888;
    //border-radius: 5px;
    padding: 15px 0;
    a {
      text-decoration: underline;
    }
  }
}

.seed-block {
  &.seed-block__hideqrcode {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: auto;
    .qrcode-side {
      display: none;
    }
  }

  .qrcode-side {
    display: grid;
    grid-gap: 25px;
    grid-template-columns: auto auto 10%;
    align-items: center;
    margin-top: 2em;
  }

  .qrcode-wrap {
    margin: 0 auto 0 auto;
    width: 250px;
    height: 250px;
    display: grid;
    align-items: center;
  }
}

.token-info {
  dl {
    text-align: center;
    dt {
      font-size: 90%;
    }
  }
  .token-info__hint {
    font-size: 95%;
    color: #777777;
    padding: 0 15px;
    text-align: center;
  }


}
.token-info__buttons {
  margin: 0.5em 0 1em 0;
  button  {
    margin: 0 auto;
    display: block;
  }
}

h3.h3__title {
  margin-bottom: 0em;
  font-weight: bolder;
  + .h3__hint {
    margin-top: 0;
  }
}
.h3__hint {
  font-size: 90%;
}


.scenario__choice {
  margin: 2em 0;
  box-sizing: border-box;
  .alert-has-already {
    .link {

      &.active {

        text-decoration: none;
      }
      &.inactive {
        text-decoration: underline;
        font-weight: bolder;
      }
    }

  }
}
.instruction {
  margin-top: 0;
  ol.numbered-list {

    display: block;
    padding: 0 0 0 40px;
    margin-left: 0;
    list-style: none;
    //overflow: hidden;
    counter-reset: numList;
    > li {

      h4.li_title {
        font-size: 17px;
        display: inline-block;
        line-height: 30px;
        margin: 0;
        padding: 0;
      }

      &.disabled-li {
        color: #888888;
        &:before {
          background: #d2d2d2;
          color: #888888;
        }
      }
      margin: 0 0 1.5em 0;
      &:last-child {
        margin-bottom: 1em;
      }
      position: relative;
      padding: 0 0 0 0;
    }

    > li:before {
      @cHeight: 25px;

      counter-increment: numList;
      content: counter(numList);

      float: left;
      position: absolute;
      left: -40px;
      top: 3px;

      font: bold 12px sans-serif;
      text-align: center;
      color: #fff;
      line-height: @cHeight;

      width: @cHeight; height: @cHeight;
      background: #80bd1c;

      -moz-border-radius: 999px;
      border-radius: 999px
    }
  }


}

label, .control-label {
  &.required {
    position: relative;
    width: auto;
    display: inline-block;
    &:after {
      color: #ee4538;
      content: "*";
      position: absolute;
      right: -7px;
      top: 0;
    }
  }
}

.notice-disabling {
  padding: 1em 0 2em 0;
}


</style>

<i18n>
{
  "en": {
    "Вернуться к настройкам безопасности": "Back to security settings page",
    "Google 2FA отключен!": "Google 2FA is disabled!",
    "enter_new_code_placeholder": "New Google 2FA code",
    "Подтверждение": "Verification",
    "Отмена": "Cancel",
    "Выберите способ подтверждения": "Select verification type",
    "page": {
      "activation_result": {
        "line1": "You have successfully activated the Google 2FA verification type.",
        "line2": "Now your account is even more secure, as you will need to use Google 2FA codes for each login."
      },
      "disable_result": {
        "line1": "You have disabled two-factor authentication. Your account's security level goes down!"
      },
      "activated_line1": "You have activated Google 2FA already.",
      "activated_line2": "You can {disablelink} or {enablelink}.",
      "activated_line2_1": "You can {enablelink}.",
      "title": "Two factor authentication",
      "activate_new_title": "Google 2FA activation",
      "activate_new_hint": "(The currently activated code will be replaced)",
      "title2": "Setup Google 2FA for making payments and login confirmation",
      "notice": {
        "hint": {
          "line1": "First download Google Authenticator app on your {android} or {ios} device.",
          "line2": "(Also supported by other apps like Authy, Microsoft Authenticator, Keepass, 1Password, etc.)",
          "line3": "If you don't have access to the Play Store or App Store, there are other options for installing Google Authenticator:"
        }
      },
      "instruction": {
        "line1": "Scan QR code in {appname} or copy {token} there manually",
        "line2": "Confirm activation request and verify new code"
      },
      "token_hint": "This token will no longer be shown after you confirm the activation."
    },
    "Введите код из приложения": "Confirm your new code from 2FA application",
    "Загрузка...": "Loading...",
    "Плагин Google Chrome": "Google Chrome plugin",
    "Токен аккаунта (ключ)": "Account token (seed)",
    "токен аккаунта": "account token",
    "Сгенерировать другой": "Generate another one",
    "Подтвердите отключение Google 2FA.": "Please confirm disabling action.",
    "Способ верификации": "Verification type",
    "Отключение Google Authenticator": "Disable the Google 2FA",
    "отключить его": "disable it",
    "активировать другой сид": "activate another seed",
    "Далее": "Next",
    "Код из Google Authenticator": "Google 2FA code",
    "Генерируется новый токен...": "Generating new token...",
    "Новый код Google 2FA": "New Google 2FA code",
    "Новый код Google Authenticator": "New Google 2FA code",
    "enter_code_hint": "Enter the new generated code from the Google Authenticator app",
    "Поздравляем!": "Congratulations!",
    "Активировать": "Activate",
    "Код из приложения": "New Google 2FA code",
    "Назад": "Back"
  },
  "ru": {
    "enter_new_code_placeholder": "Новый код Google Authenticator",
    "enter_code_hint": "Введите вновь активируемый код из приложения Google Authenticator",
    "page": {
      "disable_result": {
        "line1": "Вы отключили двухфакторную аутентификацию. Безопасность вашего аккаунта снизилась!"
      },
      "activation_result": {
        "line1": "Вы успешно активировали подпись платежей одноразовыми кодами Google Authenticator.",
        "line2": "Теперь ваш аккаунт еще более защищен, ведь для каждого входа в аккаунт необходимо будет использовать одноразовые коды."
      },
      "notice": {
        "hint": {
          "line1":  "Сначала скачайте Google Authenticator на свое устройство {android} или {ios}.",
          "line2": "(Также поддерживается другими приложениями, например Authy, Microsoft Authenticator, Keepass, 1Password и т.д.).",
          "line3": "Если у вас нет доступа к Play Store или App Store, есть другие варианты установки Google Authenticator:"
        }
      },
      "instruction": {
        "line1": "Просканируйте QR-код в приложении {appname} или скопируйте {token} туда вручную",
        "line2": "Подтвердите запрос активацию и Ваш новый код"
      },
      "token_hint": "Данный токен больше не будет показан после того, как подвердите активацию средства подписи.",
      "activate_new_title": "Активация",
      "activate_new_hint": "(Старый код перестанет действовать)",
      "activated_line1": "Сейчас у вас активировано подтверждение одноразовыми кодами Google Authenticator.",
      "activated_line2": "Вы можете {disablelink} или {enablelink}.",
      "activated_line2_1": "Вы можете {enablelink}.",
      "title2": "Настройка двухфакторной аутентификации для подтверждения платежей и входа в аккаунт",
      "title": "Настройка двухфакторной аутентификации"
    }
  }
}
</i18n>
